module.exports = __webpack_public_path__ + "static/img/banner_title.6411021.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/banner_title.png
// module id = W82B
// module chunks = 1